(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanySubscriptionStatusViewV2Controller', CompanySubscriptionStatusViewV2Controller);

    CompanySubscriptionStatusViewV2Controller.$inject = ['entity', '$state', '$scope', '$rootScope', '$stateParams', 'CompanySubscriptionStatusCustom', 'SubscriptionPackageCustom', 'CompanyInfoQuery', 'CompanyCustom', '$sce', '$location', '$anchorScroll', 'PackageFeatureListCustom', 'ActivityTypeInfoCustom', '$timeout', '$localStorage'];

    function CompanySubscriptionStatusViewV2Controller(entity, $state, $scope, $rootScope, $stateParams, CompanySubscriptionStatusCustom, SubscriptionPackageCustom, CompanyInfoQuery, CompanyCustom, $sce, $location, $anchorScroll, PackageFeatureListCustom, ActivityTypeInfoCustom, $timeout, $localStorage) {
        var vm = this;
        vm.subscriptionTypeList = [{type: 'BASIC', packages: '', isSelected: false},
            {type: 'ECONOMY', packages: '', isSelected: false},
            {type: 'ENTERPRISE', packages: '', isSelected: false}];
        vm.currentSubscriptionStatus = 'ACTIVE';

        vm.purchase = purchase;
        vm.subscriptionType = null;
        vm.selectSubscriptionType = selectSubscriptionType;
        vm.subscriptionType = 'ECONOMY';
        vm.hasCustomSubscriptionType = false;
        selectSubscriptionType();
        vm.hasSubscription = hasSubscription;

        vm.showSubscriptionType = true;
        CompanySubscriptionStatusCustom.findActiveCompanySubscription().query(function (entity) {
            vm.companySubscriptionStatusList = entity;
        });

        vm.lastSubsriptionType = "BASIC";

        CompanySubscriptionStatusCustom.findLastSubscriptionByCurrentCompany().query(function (lastSubsription) {

            if (lastSubsription) {
                vm.lastSubsriptionType = lastSubsription.subscriptionPackage.subscriptionType;
                if (vm.lastSubsriptionType == "ECONOMY") {
                    vm.subscriptionTypeList = [{type: 'ECONOMY', packages: '', isSelected: false},
                        {type: 'ENTERPRISE', packages: '', isSelected: false}];
                }
                if (vm.lastSubsriptionType == "ENTERPRISE") {
                    vm.subscriptionTypeList = [{type: 'ENTERPRISE', packages: '', isSelected: false}];

                }
            }
        })

        vm.buttonClass = buttonClass;
        vm.packageCardStyle = packageCardStyle;
        vm.borderStyle = borderStyle;
        vm.currentCompany = {};
        vm.currentCompany.activityType = "OTHER";
        findCurrentCompany();
        vm.selectSubscriptionBaseType = selectSubscriptionBaseType;
        vm.selectedSubscriptionType = null;
        vm.isAnyPackageSelected = false;
        vm.availablePackagePeriods = [];
        vm.getAvailablePackagePeriod = getAvailablePackagePeriod;
        vm.makeFeatureDesc = makeFeatureDesc;
        vm.PackageFeatureList = null;
        vm.showFeaturesClick = showFeaturesClick;
        vm.showFeatures = false;
        vm.isNativeApp = null;


        $scope.$watch('vm.companySubscriptionStatusList', function (entity) {
            if (entity) {
                loadData();
            }


        });


        function loadData() {
            makeSubscriptionPackages();
            checkSubscriptionStatus();

            //if (vm.companySubscriptionStatusList != null && vm.companySubscriptionStatusList != undefined &&  vm.companySubscriptionStatusList.length > 0) {
            //    vm.activePackage=vm.companySubscriptionStatusList[0];
            //    if (vm.companySubscriptionStatusList[0].subscriptionPackage != null) {
            //        if (vm.companySubscriptionStatusList[0].subscriptionPackage.subscriptionType != 'FREE') {
            //            vm.subscriptionType = vm.companySubscriptionStatusList[0].subscriptionPackage.subscriptionType;
            //            vm.mode = "purchase";
            //
            //            //selectSubscriptionType();
            //
            //        }
            //    }
            //}
        }

        function purchase() {
            vm.mode = "purchase";
        }

        function selectSubscriptionType() {

            CompanyInfoQuery.getCurrentCompanyInfo().query().$promise.then(function (result) {
                if (result.subscriptionType != null && result.subscriptionType != '') {
                    vm.subscriptionType = result.subscriptionType;
                    vm.showSubscriptionType = true;
                }

                vm.subscriptionPackages = SubscriptionPackageCustom.getSubscriptionPackageByType(vm.subscriptionType).query();
            })


        }

        function makeSubscriptionPackages() {

            CompanyInfoQuery.getCurrentCompanyInfo().query().$promise.then(function (result) {
                if (result.subscriptionType != null && result.subscriptionType != '') {
                    vm.subscriptionType = result.subscriptionType;
                    vm.showSubscriptionType = false;
                    vm.hasCustomSubscriptionType = false;
                    vm.subscriptionTypeList = [{type: vm.subscriptionType, packages: '', isSelected: false}];
                } else {

                }
                vm.subscriptionTypeList.forEach(function (stype) {
                    stype.packages = SubscriptionPackageCustom.getSubscriptionPackageByType(stype.type).query();
                });
            })


        }

        function checkSubscriptionStatus() {
            if (vm.companySubscriptionStatusList != null && vm.companySubscriptionStatusList != undefined && vm.companySubscriptionStatusList.length > 0) {
                vm.activePackage = vm.companySubscriptionStatusList[vm.companySubscriptionStatusList.length - 1];

                vm.currentSubscriptionStatus = 'ACTIVE';
            } else {
                vm.currentSubscriptionStatus = 'EXPIRED';
            }
        }

        function hasSubscription() {

            if (vm.companySubscriptionStatusList != null && vm.companySubscriptionStatusList != undefined && vm.companySubscriptionStatusList.length > 0) {
                if (vm.companySubscriptionStatusList[0].subscriptionPackage != null)
                    return true;
            }
            return false;
        }

        function buttonClass(type) {

            var classname = "";

            if (type != "BASIC" && type != "ECONOMY" && type != "ENTERPRISE") {
                classname = "btn-DEFAULT";
            } else {
                classname = "btn-" + type;
            }

            if (vm.isAnyPackageSelected && vm.selectedSubscriptionType != type) {
                classname += " btn-not-selected";
            }

            return classname;
        }

        function packageCardStyle(ptype) {
            if (ptype == undefined)
                return;

            var cls = "package-card-" + ptype.type;
            if (vm.isAnyPackageSelected && ptype.isSelected != true) {
                cls += " package-card-not-selected"
            }

            return cls;
        }

        function borderStyle(type) {
            return "border-" + type;
        }

        function findCurrentCompany() {
            CompanyCustom.getCurrentCompany().query().$promise.then(function (result) {
                vm.currentCompany = result;
                loadPackageFeatureList();


            });
        }

        function selectSubscriptionBaseType(pType) {

            if (pType == undefined)
                return;
            vm.selectedSubscriptionType = pType.type;
            setAllTypeAsUnSelected();
            pType.isSelected = true;
            vm.isAnyPackageSelected = true;
            getAvailablePackagePeriod();

            scrollDown();

        }

        function scrollDown() {
            $location.hash('periodSelection');
            // call $anchorScroll()
            $anchorScroll();
        }

        function setAllTypeAsUnSelected() {
            angular.forEach(vm.subscriptionTypeList, function (type) {
                type.isSelected = false;
            });
        }

        function getAvailablePackagePeriod() {
            if (!vm.isAnyPackageSelected)
                return;

            vm.availablePackagePeriods = [];

            vm.subscriptionTypeList.forEach(function (stype) {

                if (stype.type == vm.selectedSubscriptionType) {
                    vm.availablePackagePeriods = stype.packages;

                    vm.availablePackagePeriods.sort(
                        function (a, b) {
                            if (a.durationDays > b.durationDays)
                                return 1;
                            if (a.durationDays < b.durationDays)
                                return -1;
                            return 0;

                        }
                    );
                }
            });
        }

        function makeFeatureDesc(ptype) {

            var desc = "";

            if (ptype.type == "BASIC") {
                desc += '<li>   تمامی امکانات سیستم </li>';
                desc += '<li>   انتخاب <strong> 1 امکان ویژه سیستم</strong> </li>';
                desc += '<li>   رزرو<strong> نامحدود </strong> </li>';
                desc += '<li>   ارسال پیامک یادآوری </li>';
                desc += '<li>   <strong> 150 </strong> پیامک رایگان </li>';
                desc += '<li>   پشتیبانی 24 ساعته  </li>';
                desc += '<li>   حداکثر <strong> 2 پرسنل </strong> </li>';
                // desc += '<li>   پرسنل اضافه 15 هزار تومان/ماه</li>';

            }
            if (ptype.type == "ECONOMY") {
                desc += '<li>   تمامی امکانات سیستم </li>';
                desc += '<li>   انتخاب <strong> 4 امکان ویژه سیستم</strong> </li>';
                desc += '<li>   رزرو<strong> نامحدود </strong> </li>';
                desc += '<li>   ارسال پیامک یادآوری </li>';
                desc += '<li>   <strong> 300 </strong> پیامک رایگان </li>';
                desc += '<li>   پشتیبانی 24 ساعته  </li>';
                desc += '<li>   حداکثر <strong> 5 پرسنل </strong> </li>';
                // desc += '<li>   پرسنل اضافه 10 هزار تومان/ماه</li>';

            }
            if (ptype.type == "ENTERPRISE") {
                desc += '<li>  تمامی امکانات سیستم </li>';
                desc += '<li>   انتخاب <strong> 10 امکان ویژه سیستم</strong> </li>';
                desc += '<li>  رزرو<strong> نامحدود </strong> </li>';
                desc += '<li>  ارسال پیامک یادآوری </li>';
                desc += '<li>  <strong> 500 </strong> پیامک رایگان </li>';
                desc += '<li>  پشتیبانی 24 ساعته  </li>';
                desc += '<li>  حداکثر <strong> 10 پرسنل </strong> </li>';
                // desc += '<li>  پرسنل اضافه 8 هزار تومان/ماه</li>';


            }

            desc = $sce.trustAsHtml(desc);

            return desc;


        }

        function loadPackageFeatureList() {
            if (vm.currentCompany) {
                PackageFeatureListCustom.getPackageFeatureListByCompanyId(vm.currentCompany.id).query().$promise.then(function (packages) {


                    vm.packageFeatureList = packages;
                })
            }
        }

        function showFeaturesClick() {
            vm.showFeatures = !vm.showFeatures;
        }
         $timeout(function(){
            vm.isNativeApp = $localStorage.isNativeApp;
        },10)

    }
})();
